/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
export function checkboxTheme(theme, { getColor, getTextStyle }) {
  return {
    getCSS: ({ targetElement, color, isChecked, isValid, __internal__keyboardFocus }) => {
      switch (targetElement) {
        case 'container': {
          return {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          };
        }

        case 'input': {
          return {
            ...theme.focusStyles.focusVisibleAdjacentLabel,
          };
        }

        case 'label': {
          return {
            display: 'inline-flex',
            alignItems: 'flex-start',
            minHeight: '20px',
            fontSize: theme.fontSizes[0],
            fontWeight: theme.fontWeights.medium,
            lineHeight: theme.lineHeights[0],
            fontFamily: theme.fonts.body,
            color: theme.colors.black,
            whiteSpace: 'pre-line',
            backgroundColor: theme.color.white,
            borderRadius: theme.radii[0],
            ...(__internal__keyboardFocus && theme.focusStyles.__keyboardFocusAdjacentLabel),
          };
        }

        case 'svg': {
          const defaultOutline = `${theme.borderWidths[0]} solid ${theme.colors.neutrals.t700}`;
          const errorOutline = `${theme.borderWidths[0]} solid ${theme.colors.conditional.negative.graphics}`;
          return {
            flexShrink: 0,
            width: '20px',
            height: '20px',
            marginRight: theme.space[3],
            borderRadius: theme.radii[1],
            outline: isValid === false ? errorOutline : defaultOutline,
            marginTop: '2px',
          };
        }

        case 'svgRect': {
          // background of the tick mark
          return {
            fill: getColor(color === 'grey.t05' || isChecked ? 'white' : 'secondary.lightBlue.t25'),
          };
        }

        case 'svgPath': {
          // tick mark
          return {
            stroke: theme.colors.black,
          };
        }

        case 'secondaryText': {
          return {
            display: 'block',
            alignItems: 'flex-start',
            minHeight: '20px',
            fontSize: theme.fontSizes[0],
            fontWeight: theme.fontWeights.medium,
            lineHeight: theme.lineHeights[0],
            fontFamily: theme.fonts.body,
            color: theme.colors.indigo,
            whiteSpace: 'pre-line',
            marginTop: '8px',
          };
        }

        default: {
          return null;
        }
      }
    },
  };
}
